import { useState } from 'react';
import { DropdownCalendar } from 'framework/dropdown';

import cn from './CalendarPage.module.scss';

export default () => {
  const [calendar, setCalendar] = useState<string[]>([]);

  return (
    <div className={cn.wrapper}>
      <div className={cn.row}>
        <DropdownCalendar
          label="Multiple"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          min_date="05/03/2025"
          max_date="05/18/2025"
          width="300px"
          mode="multiple"
          value={calendar}
          onSelect={setCalendar}
        />
        <DropdownCalendar
          label="Range"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          width="300px"
          mode="range"
          value={calendar}
          onSelect={setCalendar}
        />
      </div>
      <div className={cn.row}>
        <DropdownCalendar
          label="Single"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          width="300px"
          mode="single"
          value={calendar}
          onSelect={setCalendar}
        />
        <DropdownCalendar
          label="Disabled"
          information="asdas asd asd as d asdkbasdk asdhjk asdhk askdj asdlk asdl asdhklas dhas kl jasdkj asdbfj kaskdfg kasjdf."
          width="300px"
          value={calendar}
          onSelect={setCalendar}
          onClick={() => console.log('click')}
          onFocus={() => console.log('focus')}
          onBlur={() => console.log('blur')}
          disabled
        />
      </div>
    </div>
  );
};
